// TestPost.js
import { useCallback } from "react";
import { useAuthorizedFetch } from "../http/useAuthorizedFetch";
// import { AuthContext } from "../../providers/AuthProvider";

const API = "https://pwa-server.test/api/v1";

/**
 * useTestPost
 * Returns a function `testPost(retry?: boolean)` that:
 *  1) POSTs /tests/tokens
 *  2) On 401/403 (and retry=true), POSTs /auth/refresh (no auto-retry),
 *     then retries /tests/tokens once (no auto-retry)
 * Logs "orig", "refresh", and "retry" payloads to mirror your original file.
 */
export function useTestPost() {
  console.log("testPost");
  const fetchWithAuth = useAuthorizedFetch();

  const testPost = useCallback(async () => {
    try {
      // Step 1: initial call (disable auto auth-retry to keep manual flow)
      let response = await fetchWithAuth(`${API}/tests/tokens`, {
        method: "POST",
        retryOnFail: true,
      });

      // Normal success
      return response; // { success: response.ok, message: "", data: {} };
    } catch (err) {
      return {
        success: false,
        message: String(err?.message || err),
        data: {},
      };
    }
  }, []);

  return testPost;
}

// export default useTestPost;

// Pre hook code
// import { getCookie } from "../../utils/Cookie"; // if you have it
// import { getCookie } from "../../utils/Cookie";
// import { useAuthorizedFetch } from "../auth/useAuthorizedFetch";
// const API = "https://pwa-server.test/api/v1";

// function parseBody(response) {
//   const ct = response.headers.get("content-type") || "";
//   if (ct.includes("application/json")) return response.json();
//   return response.text();
// }

// async function fetchWithCreds(url, options = {}) {
//   // If you use a CSRF cookie for POSTs, include it here:

//   const csrf = typeof getCookie === "function" ? getCookie("csrf_token") : null;
//   console.log("csrf: " + csrf);

//   const headers = {
//     Accept: "application/json",
//     ...(csrf ? { "X-CSRF-Token": csrf } : {}),
//     ...(options.headers || {}),
//   };

//   return fetch(url, {
//     credentials: "include", // send cookies on every request
//     ...options,
//     headers,
//   });
// }

// /**
//  * Test GET with optional one-time refresh
//  * @param {boolean} retry - whether to try one refresh+retry on 401/403
//  * @returns {Promise<{ok: boolean, status: number, data: any}>}
//  */
// export async function testPost(retry = true) {
//   try {
//     // const csrfToken = getCookie("csrf_token");

//     let response = await useAuthorizedFetch(`${API}/tests/tokens`, {
//       method: "POST",
//       // headers: {
//       //   "Content-Type": "application/json",
//       //   "X-CSRF-Token": "870892a369d94989f003e3accdad1b33",
//       // },
//     });
//     const data = await parseBody(response).catch(() => null);
//     console.log("orig: " + JSON.stringify(data));

//     if ((response.status === 401 || response.status === 403) && retry) {
//       // console.log("tests/tokens status:", response.text());

//       // Attempt refresh
//       const refreshRes = await useAuthorizedFetch(`${API}/auth/refresh`, {
//         method: "POST",
//         headers: {
//           "X-CSRF-Token": "870892a369d94989f003e3accdad1b33",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ key: "value" }),
//         credentials: "include",
//       });
//       // console.log("refresh status:", refreshRes.text());
//       const refreshData = await parseBody(refreshRes).catch(() => null);
//       console.log("refresh: " + JSON.stringify(refreshData));

//       if (!refreshRes.ok) {
//         return {
//           ok: false,
//           status: refreshRes.status,
//           data: await parseBody(refreshRes).catch(() => null),
//         };
//       }

//       // Retry original we have a valid refresh token
//       let retryRes = await useAuthorizedFetch(`${API}/tests/tokens`, {
//         method: "POST",
//         credentials: "include",
//         headers: {
//           "Content-Type": "application/json",
//           // "X-CSRF-Token": csrfToken,
//         },
//       });

//       const retryData = await parseBody(retryRes).catch(() => null);
//       console.log("retry: " + JSON.stringify(retryData));
//     }

//     // const data = await parseBody(response).catch(() => null);
//     // console.log("orig: " + data);

//     return { ok: response.ok, status: response.status, data };
//   } catch (err) {
//     return { ok: false, status: 0, data: String(err?.message || err) };
//   }
// }

//Orig
// import { getCookie } from "../../utils/Cookie";

/**
 *  Update Refresh Token
 * @returns boolean
 */
// export async function testPost() {
//   const csrfToken = getCookie("csrf_token");
//   try {
//     const response = await fetch("https://pwa-server.test/api/v1/tests/tokens", {
//       method: "POST",
//       credentials: "include",
//       headers: {
//         "Content-Type": "application/json",
//         "X-CSRF-Token": csrfToken,
//       },
//     });

//     return response.ok;
//   } catch {
//     return false;
//   }
// }
